import React from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { ReportProblemIcon } from '@components/Icons'
import { colors } from '@lib/colors'

export default function () {

  return (
      <View style={ styles.wrapper }>
        <ReportProblemIcon color={ colors.white } size={50} />
        <Text style={ styles.notice }>Something went wrong</Text>
        <Text style={ styles.explanation }>
          This crash has been reported and we're already looking into it.
          Meanwhile, please try reloading the app.
        </Text>
      </View>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.red[600],
    paddingLeft: 20,
    paddingRight: 20,
  },
  notice: {
    color: colors.white,
    fontSize: 25,
    marginTop: 10,
  },
  explanation: {
    color: colors.white,
    textAlign: 'center',
    marginTop: 20,
  },
})
